import {
  CREATE_AUTH_GROUP,
  DELETE_AUTH_GROUP,
  EDIT_AUTH_GROUP,
  RECEIVE_AUTH_GROUPS,
  REQUEST_ALL_AUTH_GROUPS,
  REQUEST_AUTH_GROUP,
} from '@sophocles/entities/AuthGroup/authGroupActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_AUTH_GROUPS: // Read
      return state.merge(action.authGroups);
    case DELETE_AUTH_GROUP: // Delete
      return state.delete(action.authGroup.toString());
    case EDIT_AUTH_GROUP: // Update
    case CREATE_AUTH_GROUP: // Create
    case REQUEST_AUTH_GROUP:
    case REQUEST_ALL_AUTH_GROUPS:
    default:
      return state;
  }
}

export function authGroupReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_AUTH_GROUP:
    case DELETE_AUTH_GROUP:
    case RECEIVE_AUTH_GROUPS:
    case EDIT_AUTH_GROUP:
    case REQUEST_AUTH_GROUP:
    case REQUEST_ALL_AUTH_GROUPS:
      return getState(state, action);
    default:
      return state;
  }
}
